import { render, staticRenderFns } from "./agam_Home.vue?vue&type=template&id=76dd16ea&"
import script from "./agam_Home.vue?vue&type=script&lang=js&"
export * from "./agam_Home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports